<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="Transacciones totales"
          :value="'$'+totalTransactions"
          :percentage="{
            value: '+505%',
            color: 'text-success',
          }"
          :icon="{
            component: 'ni ni-money-coins',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0">
        <mini-statistics-card
            title="Comisiones totales"
            :value="'$'+totalCommissions"
            :percentage="{
            value: '+5%',
            color: 'text-success',
          }"
            :icon="{
            component: 'ni ni-cart',
            background: iconBackground,
          }"
            direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="Prospectos totales"
          :value="total_leads"
          :percentage="{
            value: '+3%',
            color: 'text-success',
          }"
          :icon="{
            component: 'ni ni-world',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="Clientes totales"
          :value="total_clients"
          :percentage="{
            value: '-2%',
            color: 'text-danger',
          }"
          :icon="{
            component: 'ni ni-paper-diploma',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
    </div>
    <div class="row" v-if="chartData">
      <div class="w-100">
        <select class="form-control" @change="getChart" v-model="day_selected">
          <option value="30">30 Dias</option>
          <option value="60">60 Dias</option>
          <option value="90">90 Dias</option>
          <option value="120">120 Dias</option>
          <option value="150">150 Dias</option>
          <option value="180">180 Dias</option>
        </select>
      </div>
      <div class="col" v-if="renderComponent">
        <gradient-line-chart
            id="chart-line"
            title="Transacciones vs Comisiones"
            description=""
            :chart="chartData"
        />
      </div>
    </div>
  </div>
</template>
<script>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import {get} from "@/utils/httpRequest";
export default {
  name: "dashboard-default",
  components: {
    MiniStatisticsCard,
    GradientLineChart,
  },
  data : () => ({
    iconBackground: "bg-gradient-success",
    arrayTransactions: [],
    totalTransactions: 0,
    totalCommissions: 0,
    arrayUsers: [],
    total_clients: 0,
    total_clients_today: 0,
    total_leads: 0,
    chartData: null,
    day_selected: 30,
    renderComponent: true,
    chartConfig: {
      type: 'line',
      data: null,
      options: {}
    }
  }),
  mounted() {
    this.getTransactionsReport()
    this.getUsersReport()
    this.getCommissionReport()
    this.getChart()
  },
  methods: {
    async getChart(){
      this.renderComponent = false
      const {data} = await get(`transactions/get-chart?days=${this.day_selected}`)
      data.labels = data.labels.reverse()
      this.chartData = data
      this.chartConfig.data = this.chartData
      await this.$nextTick()
      this.renderComponent = true
    },
    async getUsersReport(){
      const {data} = await get("users/report")
      this.arrayUsers = data.clients_today;
      this.total_clients = data.clients
      this.total_leads = data.leads
      this.total_clients_today = data.total_clients_today
    },
   async getTransactionsReport(){
      const {data} = await get("transactions/report")
     this.arrayTransactions = []
     this.totalTransactions = data
    },

    async getCommissionReport(){
      const {data} = await get("commissions/report")
      if(data.length){
        this.totalCommissions = data[0].totalAmount
      }
    },
    vieDetail(item){
      this.$router.push({name:'users-view', query: {id: item._id}})
    }
  }
};
</script>
<style scoped lang="scss">
@media (max-width: 767px) {
  .margin_top_mobile {
    margin-top: 1.5rem !important;
  }
}
</style>
